import { useId } from 'react'

import { Checkbox } from '@/components/ui/checkbox'

const NotificationTypeFilterItem = ({
  title,
  value,
  onCheckedChange,
}: {
  title: string
  value: boolean
  onCheckedChange: (_value: boolean) => void
}) => {
  const id = useId()

  // handler to toggle the checkbox value
  const handleToggle = () => {
    onCheckedChange(!value)
  }

  return (
    <div
      className="flex w-full flex-1 cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 hover:bg-base-sidebar-accent"
      onClick={handleToggle}
    >
      <Checkbox
        id={id}
        checked={value}
        onCheckedChange={onCheckedChange}
        className="shrink-0"
        onClick={(e) => e.stopPropagation()}
      />
      <label htmlFor={id} className="user-select-none cursor-pointer text-sm" onClick={(e) => e.stopPropagation()}>
        {title}
      </label>
    </div>
  )
}
NotificationTypeFilterItem.displayName = 'NotificationTypeFilterItem'

export { NotificationTypeFilterItem }
